export const LAST_DAMAGE_REPORT_RECEIVED = 'dashboard/Dashboard/LAST_DAMAGE_REPORT_RECEIVED'
export const RENTAL_EXPIRATION_STATISTICS_BY_PROJECT_RECEIVED =
  'dashboard/Dashboard/RENTAL_EXPIRATION_STATISTICS_BY_PROJECT_RECEIVED'
export const DRUM_STATISTICS_RECEIVED = 'dashboard/Dashboard/DRUM_STATISTICS_RECEIVED'
export const UPCOMING_DELIVERIES_RECEIVED = 'dashboard/Dashboard/UPCOMING_DELIVERIES_RECEIVED'
